module.exports = __webpack_public_path__ + "assets/img/d497-ug.svg";